import { EStatus } from '../../repositories/newbuilding-card/entities/reviews/LikeSchema';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EReviewsActionTypes {
  SetReviewReaction = 'reviews/setReviewReaction',
}

export type TSetReviewReactionActionPayload = {
  reviewId: string;
  type: EStatus;
};

export type TSetReviewReaction = ITypedReduxAction<
  EReviewsActionTypes.SetReviewReaction,
  TSetReviewReactionActionPayload
>;

/**
 * Redux action, который записывает в store новый лайк/дизлайк пользователя
 */
export const setReviewReactionAction: (payload: TSetReviewReactionActionPayload) => TSetReviewReaction =
  actionGenerator<EReviewsActionTypes.SetReviewReaction, TSetReviewReactionActionPayload>(
    EReviewsActionTypes.SetReviewReaction,
  );
